import { useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { MainContext } from "../../contexts/MainContext";


// const scriptSourceUrl = 'http://localhost:3000/bots/chatbot.min.js'
// const scriptSourceUrl = 'http://localhost:4200/bots/chatbot.min.js'
const scriptSourceUrl = 'https://makin-tools.netlify.app/bots/chatbot.min.js';
const ChatbotInjector = () => {
    const { userData, jwt } = useContext(MainContext);
    const location = useLocation();
    const hasRendered = useRef(false);

    useEffect(() => {
        const containerId = "chatbot-container";

        // Espera JWT e userId antes de iniciar
        if (!jwt || !userData?.userId) {
            console.warn("⏳ Aguardando dados do usuário...");
            return;
        }

        // Evita renderização múltipla
        if (hasRendered.current) return;
        hasRendered.current = true;

        // Cria script
        const script = document.createElement("script");
        script.src = scriptSourceUrl;
        script.async = true;
        document.body.appendChild(script);

        // Cria container do chatbot
        const container = document.createElement("div");
        container.id = containerId;
        // container.style.position = "fixed";
        // container.style.bottom = "20px";
        // container.style.right = "20px";
        // container.style.zIndex = "9999";
        document.body.appendChild(container);

        const loadCustomStyles = async () => {
            try {
                const css = await fetch("/css/chatbot-styles.css").then(res => res.text());
                console.log(css);
                return css;
            } catch {
                return "";
            }
        };

        const tryRender = async () => {
            const customStyles = await loadCustomStyles();

            const config = {
                botName: "Invest Bot",
                baseHost: "https://api.aminhacarteira.com.br",
                jwt,
                userId: userData.userId,
                name: userData.name || "visitante",
                urlPath: location.pathname,
                initialMessages: [`Oi ${userData.name || "visitante"}! Como posso ajudar?`],
                inputPlaceholder: "Digite sua dúvida...",
                customStyles,
                mode: "investbot",
            };

            console.log("✅ Enviando config via postMessage", config);

            if (
                window.MakinToolsAiChatBot &&
                typeof window.MakinToolsAiChatBot.renderChatbot === "function"
            ) {
                window.MakinToolsAiChatBot.renderChatbot(container, config);

                // Espera um pouquinho antes de enviar o postMessage
                setTimeout(() => {
                    window.postMessage(config, "*");
                }, 200);
            } else {
                console.warn("⏳ Aguardando carregamento do chatbot...");
                setTimeout(tryRender, 300);
            }
        };

        // Aguarda script carregar e renderizar o chatbot
        const interval = setInterval(() => {
            if (window.MakinToolsAiChatBot) {
                clearInterval(interval);
                tryRender();
            }
        }, 300);

        // Cleanup
        return () => {
            container.remove();
            script.remove();
            clearInterval(interval);
        };
    }, [jwt, userData?.userId, location.pathname]);

    return null;
};

export default ChatbotInjector;
